module.exports = __webpack_public_path__ + "img/footer.3de29710.svg";